<template>
    <div
        class="tableRow"
        v-if="$mq == 'desktop'"
        @mouseover="handleMouseOver"
        @mouseout="handleMouseOut"
        @click="handleClick"
    >
        <div id="titleCont">
            <div id="title" class="left">{{ project.title }}</div>
            <div id="year" class="right tabNum" v-html="getYear"></div>
        </div>
        <div id="clientCont">
            <div id="type" class="left">{{ project.category.name }}</div>
            <div id="client" class="left">{{ project.client }}</div>
            <div id="images" class="right">
                <span
                    ref="imageNumber"
                    class="imageNumber tabNum"
                    v-show="true"
                    v-html="getImageNumber"
                ></span>
                <!--
            <img ref="imageImage" class="imageImage" :src="project.images[0].thumbnail_small" v-show="false"></img>
            --></div>
        </div>
    </div>
    <div
        class="tableRow mobile"
        v-else
        @mouseover="handleMouseOver"
        @mouseout="handleMouseOut"
        @click="handleClick"
    >
        <div id="title" class="left">{{ project.title }}</div>
        <div v-if="getSecondarySorting == 'type'" id="type" class="right">
            {{ project.category.name }}
        </div>
        <div
            v-else-if="getSecondarySorting == 'client'"
            id="client"
            class="right"
        >
            {{ project.client }}
        </div>
        <div
            v-else-if="getSecondarySorting == 'year_order'"
            id="year"
            class="right tabNum"
            v-html="getYear"
        ></div>
    </div>
</template>

<script>
import { store } from "@/centralStore";
export default {
    name: "IndexItem",
    props: ["project"],
    data() {
        return {
            store: store.state,
            secondarySorting: "year_order"
        };
    },
    computed: {
        getImageNumber() {
            return this.project.images.filter(
                i => i.is_paired_with_next == false
            ).length;
        },
        getSecondarySorting() {
            if (this.store.sorting != "title") {
                this.secondarySorting = this.store.sorting;
            }
            return this.secondarySorting;
        },
        getYear() {
            var str;
            if (this.project.start_year && this.project.end_year) {
                str =
                    new Date(this.project.start_year).getFullYear() +
                    "&ndash;" +
                    new Date(this.project.end_year)
                        .getFullYear()
                        .toString()
                        .substr(-2);
            } else if (this.project.start_year) {
                if (this.project.ongoing) {
                    str =
                        new Date(this.project.start_year).getFullYear() +
                        "&ndash;" +
                        new Date()
                            .getFullYear()
                            .toString()
                            .substr(-2);
                } else {
                    str = new Date(this.project.start_year).getFullYear();
                }
            } else if (this.project.end_year) {
                str = new Date(this.project.end_year).getFullYear();
            }
            return str;
        },
        getCurrentImage() {
            var myself = this;
            if (myself.store.currentImage) {
                if (myself.store.currentImage.project == myself.project.id) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        handleMouseOver() {
            //this.$refs.imageNumber.style.display = 'none';
            //this.$refs.imageImage.style.display = 'block';
        },
        handleMouseOut() {
            //if (!this.getCurrentImage){
            //this.$refs.imageNumber.style.display = 'inline';
            //this.$refs.imageImage.style.display = 'none';
            //}
        },
        handleClick() {
            let myself = this;
            this.store.random = false;
            this.store.indexTransition = "slideDown";
            this.store.detailTransition = "slideUp";
            setTimeout(function() {
                myself.$router.push({
                    name: "detail-slug",
                    params: { slug: myself.project.slug }
                });
            }, 100);
        }
    }
};
</script>

<style scoped>
td {
}
tr {
    border-top: 1px solid black;
    border-bottom: none;
    cursor: pointer;
}
tr:first-child {
    border-top: none;
}
tr:hover {
    color: #969696;
}
td {
}
td.left {
    text-align: left;
}
td.right {
    text-align: right;
}
#titleCont,
#clientCont {
    flex-basis: 50%;
    display: flex;
    min-width: 0;
}
#title {
    /*width: 33.3%;*/
    flex: 3;
    white-space: nowrap;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    margin-right: 1rem;
    position: relative;
    max-width: 100%;
}
#title::before {
    content: "";
    position: absolute;
    top: 0;
    left: calc(100% - 4rem + 2px);
    height: 100%;
    width: 4rem;
    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0), black);
    background-image: linear-gradient(left, rgba(0, 0, 0, 0), black);
}
#year {
    /*width: 16.6%;*/
    text-align: right;
    margin-right: 0.5rem;
}
#type {
    /*width: 16.6%;*/
    margin-left: 0.5rem;
    /*flex-basis: 188px;*/
    flex-basis: 33%;
}
#client {
    /*width: 16.6%;*/
    flex: 3;
}
#images {
    /*width: 16.6%;*/
    text-align: right;
}

.mobile > #title {
    width: auto;
    flex: 1;
    white-space: nowrap;
    /*text-overflow: ellipsis;*/
    overflow: hidden;
}
.mobile > #type {
    text-align: right;
    width: auto;
    margin-left: 0rem;
    flex-basis: auto;
}
.mobile > #client {
    text-align: right;
    width: auto;
    margin-left: 0rem;
    flex: 0;
    flex-basis: auto;
}
.mobile > #year {
    text-align: right;
    width: auto;
    /*margin-left: 1rem;*/
    margin-right: 0;
    /*flex-basis: 3.7rem;*/
    flex-basis: auto;
}
.imageImage {
    height: 35px;
    display: block;
    float: right;
}

.tableRow {
    border-bottom: 1px solid #565656;
    display: flex;
    padding-top: 0.55rem;
    padding-bottom: 0.55rem;
    cursor: pointer;
}
@media screen and (min-width: 768px) {
    .tableRow {
        padding-top: 0.32rem;
        padding-bottom: 0.35rem;
    }
}
.tableRow:last-child {
    margin-bottom: 1rem;
}
.tableRow:hover {
    color: #969696;
    /*border-bottom: 1px solid #969696;;*/
}
</style>
